// import React from 'react'
// import '../NewDesigns/style.css'
//  const CustomProgressBar=({percentage,progressColor})=> {
//   return (
//     <div className="progress-container">
//     <div
//         className="progress-circle"
//         style={{
//         background: `conic-gradient(${progressColor} ${percentage * 3.6}deg, #f0f0f0 0deg)`,
//         }}
//     >
//         <div className="progress-text "><span className='f-light ' style={{fontSize: '10px'}}>{percentage?.toFixed(0)}%</span></div>
//     </div>
// </div>
//   )
// }
// export default CustomProgressBar
import React from 'react'
import '../NewDesigns/style.css'

const CustomProgressBar = ({ percentage }) => {
  // Determine color based on percentage
  const getProgressColor = (value) => {
    if (value === 100) return '#54BA4A'; // green
    if (value > 95) return '#FFC107';   // amber
    return '#F44336';                   // red
  };

  const progressColor = getProgressColor(percentage);

  return (
    <div className="progress-container">
      <div
        className="progress-circle"
        style={{
          background: `conic-gradient(${progressColor} ${percentage * 3.6}deg, #f0f0f0 0deg)`,
        }}
      >
        <div className="progress-text">
          <span className="f-light" style={{ fontSize: '10px' }}>
            {/* {percentage?.toFixed(0)}% */}
            {percentage % 1 === 0 ? parseInt(percentage) : percentage.toFixed(1)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default CustomProgressBar;
